import configureStore from './configureStore'; // Initial Redux Store

const store = configureStore();
// loadState(store);

export default store;